import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceSemicolon'
})
export class ReplaceSemicolonPipe implements PipeTransform {

  transform(value: string): any {
  
    let resultado="";
    if ( value == null || value.length == 0) {
      resultado = '';
    } else {
      if ( value.includes(';') ) {
        if(value.charAt(value.length-1)==";"){
          resultado=value.substring(0,(value.length-1)).replace(/;/g,',');
        }else{
          resultado=value.replace(/;/g,',');
        }
    
      } else {
        resultado = value;
      }
    }
    
    
    
    return resultado;
  }

}
